export default __webpack_public_path__ + "static/media/icono-usuario.fce2861b.svg";